export default __webpack_public_path__ + "static/media/horizontales-LC3.d1e69317.jpg";